import utils from '../utils'
import api from '../apis'
var action = {
    actions: [],
    clears: [],
    roots: [],
    groups: []
}
export default {
    state: {
        action: action,
        current: {}
    },
    getters: {
        action(state) {
            return state.action;
        },
        actions(state) {
            return state.action.actions;
        },
        clears(state) {
            return state.action.clears;
        },
        roots(state) {
            return state.action.roots;
        },
        currentAction(state) {
            return state.current;
        },
        sitePath(state) {
            if (!state.current) {
                return [];
            }
            var act = state.current;
            var menus = [];
            while (act != undefined) {
                if (act.ActionURL && act.ActionURL != '') {
                    menus.push(act);
                }
                act = act.upper;
            }
            return menus.reverse();
        },
        childActions(state) {
            if (!state.current) {
                return state.current;
            }
            return state.current.children;
        },
        groups(state) {
            return state.action.groups;
        }
    },
    mutations: {
        setActionInfo(state, acts) {
            // utils.cache(cacheKey, actionInfo)
            state.action = acts;
        },
        removeActionInfo(state) {
            state.action = action;
        },
        changeAction(state, action) {
            state.current = action;
        }
    },
    actions: {
        removeActionInfo({
            commit
        }) {
            commit('removeActionInfo')
        },
        changeCurrentAction({
            commit
        }, action) {
            commit("changeAction", action);
        },
        loadActionInfo({
            commit
        }, UserID, CompanyID) {
            return api.system.getUserActions({
                failTips: false
            }).then(function (json) {
                if (!json.data.isSucc) {
                    return json;
                }
                var result = json.data.result;
                var ents = result.UserActions;
                var acts = _.clone(ents);
                _.remove(acts, o => o.ActionCode == '');
                var actions = _.groupBy(ents, 'UpperAction');
                _.forEach(ents, function (ent) {
                    if (actions[ent.ActionID]) {
                        ent.children = _.orderBy(actions[ent.ActionID],'OrderBy');
                        _.forEach(ent.children, function (a) {
                            a.upper = ent;
                        })
                    }
                    ent.IdentifyPath = ent.ActionPath || ent.ActionCode;
                });
                // var companyMain = _.find(ents, o => o.ModuleCode.toUpperCase() == "CompanyMain".toUpperCase());
                // var userMain = _.find(ents, o => o.ModuleCode.toUpperCase() == "UserMain".toUpperCase());
                // if (companyMain && userMain) {
                //     userMain.children.push(companyMain);
                //     //companyMain.upper = userMain;
                // }
                commit('setActionInfo', {
                    actions: ents,
                    clears: acts,
                    roots: actions[0],
                    groups: actions
                });
                return json;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/actionStore.js